/* eslint-disable showpass-custom/no-hardcoded-colors */
/* eslint-disable showpass-custom/no-hardcoded-style-values */
import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function CampaignMonitor({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <CampaignMonitor.Outline {...props} />
  ) : (
    <CampaignMonitor.Solid {...props} />
  );
}

CampaignMonitor.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <g clipPath="url(#clip0_2852_20237)">
          <path
            d="M45.2103 0.733672C44.5947 -0.0663281 43.6372 -0.199661 42.8164 0.333672L0.4104 29.3337C0.683988 29.8003 1.29956 30.0003 1.77834 30.0003H43.8424C44.7999 30.0003 45.5523 29.2003 45.5523 28.3337V1.66701C45.4839 1.40034 45.4155 1.00034 45.2103 0.733672Z"
            fill="#7856FF"
          />
          <path
            d="M2.66748 0.333242C1.91511 -0.266758 0.820762 -0.0667584 0.273587 0.733242C0.0683968 0.999908 0 1.33324 0 1.66657V28.3332L20.2455 12.1999L2.66748 0.333242Z"
            fill="#7856FF"
          />
        </g>
        <defs>
          <clipPath id="clip0_2852_20237">
            <rect width="45.4839" height="30" fill="white" />
          </clipPath>
        </defs>
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

CampaignMonitor.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <g clipPath="url(#clip0_2852_20237)">
          <path
            d="M45.2103 0.733672C44.5947 -0.0663281 43.6372 -0.199661 42.8164 0.333672L0.4104 29.3337C0.683988 29.8003 1.29956 30.0003 1.77834 30.0003H43.8424C44.7999 30.0003 45.5523 29.2003 45.5523 28.3337V1.66701C45.4839 1.40034 45.4155 1.00034 45.2103 0.733672Z"
            fill="#7856FF"
          />
          <path
            d="M2.66748 0.333242C1.91511 -0.266758 0.820762 -0.0667584 0.273587 0.733242C0.0683968 0.999908 0 1.33324 0 1.66657V28.3332L20.2455 12.1999L2.66748 0.333242Z"
            fill="#7856FF"
          />
        </g>
        <defs>
          <clipPath id="clip0_2852_20237">
            <rect width="45.4839" height="30" fill="white" />
          </clipPath>
        </defs>
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
